// Phase G3 Stage 3: /parent/portfolio — kid handwriting-trace gallery.
// G3 ships UI only; signed-URL fetch logic stubbed (Phase H wires).
import { createFileRoute } from "@tanstack/react-router";
import { ParentPortfolio } from "@/screens/ParentPortfolio";
export const Route = createFileRoute("/parent/portfolio")({
  component: ParentPortfolio,
});
